module.exports = __webpack_public_path__ + "static/media/clientPhoto3.91d5a89a.png";